import { IconSets } from "@toruslabs/vue-components";
import {
  ArrowDownIcon,
  ArrowNarrowDownIcon,
  ArrowNarrowRightSolidIcon,
  ArrowUpIcon,
  ChevronDownIcon,
  ChevronDownSolidIcon,
  ChevronLeftIcon,
  ChevronLeftSolidIcon,
  ChevronRightIcon,
  ChevronRightSolidIcon,
  ChevronUpIcon,
  ChevronUpSolidIcon,
  SwitchVerticalIcon,
} from "@toruslabs/vue-icons/arrows";
import {
  AppleIcon,
  DiscordIcon,
  FacebookIcon,
  GithubIcon,
  GoogleIcon,
  KakaoIcon,
  LineIcon,
  LinkedinIcon,
  RedditIcon,
  TwitchIcon,
  TwitterIcon,
  WechatIcon,
} from "@toruslabs/vue-icons/auth";
import { BellIcon, ChatCircleIcon } from "@toruslabs/vue-icons/chatting";
import { WifiIcon } from "@toruslabs/vue-icons/connection";
import {
  BookOpenIcon,
  ClipboardCopyIcon,
  ClipboardListIcon,
  CollectionIcon,
  DocumentDuplicateIcon,
  DocumentDuplicateSolidIcon,
} from "@toruslabs/vue-icons/file";
import { MobileIcon } from "@toruslabs/vue-icons/gadgets";
import { ExternalLinkIcon, PencilIcon, PencilSolidIcon } from "@toruslabs/vue-icons/mail";
import { GlobeSolidIcon, HomeSolidIcon, MoonIcon, SearchSolidIcon } from "@toruslabs/vue-icons/maps";
import { MenuAltOneIcon } from "@toruslabs/vue-icons/menu";
import {
  CheckCircleSolidIcon,
  CheckIcon,
  ExclamationCircleIcon,
  LogoutIcon,
  PlusCircleIcon,
  PlusIcon,
  XCircleSolidIcon,
  XIcon,
  XSolidIcon,
} from "@toruslabs/vue-icons/notifications";
import { AdjustmentsIcon, CalendarIcon, HeartSolidIcon, SparklesIcon, SunSolidIcon, TrashIcon } from "@toruslabs/vue-icons/others";
import { EyeOffSolidIcon, EyeSolidIcon, InformationCircleIcon, KeyIcon, LockClosedIcon } from "@toruslabs/vue-icons/security";
import { DownloadIcon, QrcodeIcon } from "@toruslabs/vue-icons/software";
import { UserCircleIcon, UserCircleSolidIcon } from "@toruslabs/vue-icons/users";

import ArrowLeftLong from "./ArrowLeftLong.vue";
import ArrowRightLong from "./ArrowRightLong.vue";
import TrustLine from "./TrustLine.vue";
import Wallet from "./Wallet.vue";
import WalletConnect from "./WalletConnect.vue";

export default {
  AdjustmentsIcon,
  ArrowRightLong,
  ArrowDownIcon,
  ArrowUpIcon,
  ArrowNarrowDownIcon,
  BellIcon,
  BookOpenIcon,
  CalendarIcon,
  ChatCircleIcon,
  ChevronDownIcon,
  ChevronDownSolidIcon,
  ChevronLeftIcon,
  ChevronLeftSolidIcon,
  ChevronRightIcon,
  ChevronRightSolidIcon,
  ChevronUpSolidIcon,
  ClipboardListIcon,
  ClipboardCopyIcon,
  DocumentDuplicateSolidIcon,
  DownloadIcon,
  ExclamationCircleIcon,
  ExternalLinkIcon,
  EyeOffSolidIcon,
  EyeSolidIcon,
  GlobeSolidIcon,
  GoogleIcon,
  HeartSolidIcon,
  HomeSolidIcon,
  InformationCircleIcon,
  KeyIcon,
  LockClosedIcon,
  LogoutIcon,
  MenuAltOneIcon,
  MobileIcon,
  MoonIcon,
  PencilIcon,
  PencilSolidIcon,
  PlusCircleIcon,
  PlusIcon,
  QrcodeIcon,
  SearchSolidIcon,
  SparklesIcon,
  SwitchVerticalIcon,
  SunSolidIcon,
  TrashIcon,
  TrustLine,
  UserCircleIcon,
  Wallet,
  WalletConnect,
  WifiIcon,
  XSolidIcon,
  XCircleSolidIcon,
  CollectionIcon,
  CheckCircleSolidIcon,
  FacebookIcon,
  AppleIcon,
  DiscordIcon,
  TwitchIcon,
  TwitterIcon,
  KakaoIcon,
  RedditIcon,
  GithubIcon,
  LineIcon,
  WechatIcon,
  LinkedinIcon,
  ArrowNarrowRightSolidIcon,
  UserCircleSolidIcon,
  ArrowLeftLong,
  ChevronUpIcon,
  CheckIcon,
  XIcon,
  DocumentDuplicateIcon,
} as unknown as IconSets;
